import React from 'react';
import {Card, CardActions, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import LocalShippingIcon from 'material-ui/svg-icons/maps/local-shipping';
import StoreMallIcon from 'material-ui/svg-icons/maps/store-mall-directory';
import { Link } from 'react-router-dom';
import retailerImage from './../../media/store-header.jpg';
import './Retailer.css';

const styles = {
  retailerStyle: {
    margin: 10,
    maxWidth: 360,
  },
  iconStyle: {
    color: "#689F38",
  },
};

const primary = "Local Delivery"
const secondaryAvailable = "Available";
const secondaryNotAvailable = "Not Available";

const Retailer = props => (
  <Card style={styles.retailerStyle}>
    <CardMedia><img src={retailerImage} className="header-image" alt="logo" /></CardMedia>
    <CardTitle title={props.retailer.name} subtitle={<Address retailer={props.retailer} /> }  />
    <CardText>
      <div className="retailer">
        <div className="facilities">
          {getDeliveryItem(props.retailer, props.destZipcode, props.deliveryMatch)}
          <Facility primaryText="Curbside Pickup" secondaryText={secondaryAvailable} leftIcon={<StoreMallIcon />} />
        </div>
      </div>
    </CardText>
    <CardActions>
      <RaisedButton primary={true} label="Shop Now" onTouchTap={shopStore(props.retailer)} fullWidth={true}/>
    </CardActions>
  </Card>
);

Retailer.propTypes = {
  retailer: React.PropTypes.object.isRequired,
  deliveryMatch: React.PropTypes.bool,
  destZipcode: React.PropTypes.string,
  shopNowFunc: React.PropTypes.func,
}

export default Retailer

function getDeliveryItem(retailer, destZipcode, deliveryMatch) {
  var primaryWithZipcode = "Local Delivery to " + destZipcode;
  if (!retailer.offers_delivery){
    return <Facility primaryText={primary}  secondaryText={secondaryNotAvailable} leftIcon={<LocalShippingIcon />} />
  } else if (destZipcode && deliveryMatch) {
    return <Facility primaryText={primaryWithZipcode} secondaryText={secondaryAvailable} leftIcon={<LocalShippingIcon />} />
  }else if (destZipcode && !deliveryMatch) {
    return <Facility primaryText={primaryWithZipcode} secondaryText={secondaryNotAvailable} leftIcon={<LocalShippingIcon />} disabled={true}/>
  }else {
    return <Facility primaryText={primary}  secondaryText={secondaryAvailable} leftIcon={<LocalShippingIcon />} action={<EnterZip />}/>
  }
}


const Address = props => (
  <div>
    <div>{props.retailer.addressline1}</div>
    <div>{props.retailer.city}, {props.retailer.state}, {props.retailer.zipcode}</div>
  </div>
);

Address.propTypes = {
  retailer: React.PropTypes.object,
}

const Facility = props => (
  <div className={props.disabled ? "facility disabled" : "facility"}>
    {props.leftIcon}
    <div>
      <div className="facility-part">{props.primaryText}</div>
      <div className="facility-part"><strong>{props.secondaryText}</strong></div>
      {props.action}
    </div>
  </div>
);

Facility.defaultProps ={
  disabled: false
}

Facility.propTypes = {
  primaryText: React.PropTypes.string.isRequired,
  secondaryText: React.PropTypes.string.isRequired,
  footerText: React.PropTypes.string,
  leftIcon: React.PropTypes.object,
  disabled: React.PropTypes.bool,
}

const EnterZip = () => (
  <Link to="/" className="facility-part">Check Your Zip Code</Link>
);

function shopStore(retailer) {
  return function() {
    // save user preferred store
     localStorage.setItem('selectedStore', retailer.store);
    
    // transition to the main store
    window.location = retailer.store;
  }
}



// WEBPACK FOOTER //
// ./src/components/retailers/Retailer.js